// extracted by mini-css-extract-plugin
export default {"root":"CurrencySymbol_root__ns3-i"};